import { put, takeLatest } from 'redux-saga/effects';
import groupSessionApi from 'api/graphql/groupSession';
import groupSessionSlice from 'store/modules/groupSession';
import uiSlice from 'store/modules/ui';
import { createSnack, getUserFriendlyError } from 'common/utils/general';
import i18n from 'i18n';

function* create(action) {
  try {
    yield groupSessionApi.create(action.payload);

    const snack = createSnack({
      key: 'create-group-session-success',
      variant: 'success',
      message: i18n.t('groupSession.create', { ns: 'notifications' })
    });

    yield put(groupSessionSlice.actions.createSuccess());
    yield put(uiSlice.actions.enqueueSnackbar(snack));
  } catch (ex) {
    const message = getUserFriendlyError(ex);
    yield put(groupSessionSlice.actions.createError(message));
  }
}

function* list(action) {
  try {
    const response = yield groupSessionApi.list(action.payload);
    const { groupSessions } = response.data;
    yield put(groupSessionSlice.actions.listSuccess(groupSessions));
  } catch (ex) {
    yield put(groupSessionSlice.actions.listError());
  }
}

function* fetchMyGroupSessions() {
  try {
    const response = yield groupSessionApi.myGroupSessions();
    yield put(
      groupSessionSlice.actions.fetchMyGroupSessionsSuccess(response.data.myGroupSessions)
    );
  } catch (ex) {
    yield put(groupSessionSlice.actions.fetchMyGroupSessionsError());
  }
}

function* update(action) {
  try {
    yield groupSessionApi.update(action.payload);

    const snack = createSnack({
      key: 'update-group-session-success',
      variant: 'success',
      message: i18n.t('groupSession.update', { ns: 'notifications' })
    });

    yield put(groupSessionSlice.actions.updateSuccess());
    yield put(uiSlice.actions.enqueueSnackbar(snack));
  } catch (ex) {
    yield put(groupSessionSlice.actions.updateError());
  }
}

function* markAttendance(action) {
  try {
    yield groupSessionApi.markAttendance(action.payload);

    const snack = createSnack({
      key: 'mark-attendance-success',
      variant: 'success',
      message: i18n.t('groupSession.attendance', { ns: 'notifications' })
    });

    yield put(groupSessionSlice.actions.markAttendanceSuccess());
    yield put(uiSlice.actions.enqueueSnackbar(snack));
  } catch (ex) {
    yield put(groupSessionSlice.actions.markAttendanceError());
  }
}

function* deleteSession(action) {
  try {
    yield groupSessionApi.deleteSession(action.payload);

    const snack = createSnack({
      key: 'delete-group-session-success',
      variant: 'success',
      message: i18n.t('groupSession.delete', { ns: 'notifications' })
    });

    yield put(groupSessionSlice.actions.deleteSessionSuccess());
    yield put(uiSlice.actions.enqueueSnackbar(snack));
  } catch (ex) {
    yield put(groupSessionSlice.actions.deleteSessionError());
  }
}

export default function* watchGroupSession() {
  yield takeLatest(groupSessionSlice.actions.create, create);
  yield takeLatest(groupSessionSlice.actions.list, list);
  yield takeLatest(groupSessionSlice.actions.fetchMyGroupSessions, fetchMyGroupSessions);
  yield takeLatest(groupSessionSlice.actions.update, update);
  yield takeLatest(groupSessionSlice.actions.markAttendance, markAttendance);
  yield takeLatest(groupSessionSlice.actions.deleteSession, deleteSession);
}
